const getState = (state) => state.notification;

export const getNotificationOpen = (state) => getState(state).open;
export const getMessage = (state) => getState(state).message;
export const getError = (state) => getState(state).error;
